(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'VideoFilter',
	};

	var $modal = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function success(response)
	{
		var catId       = '';
		var catSelect   = $modal.find('#videofilter-agent_video_category_id').val();
		var parentGroup = $modal.find("#videofilter-agent_video_category_id :selected").parent().attr('label');

		if ((catSelect === '' || catSelect === null) || parentGroup === 'Global Categories') {
			$('.edit-video-subcat').addClass('hidden');
		}

		$modal.find('.video-filter-clear').on('click', function _clearSearch(e) {
			var source = $('#video-library-source').val();

			e.preventDefault();

			if (source === 'liveplanner') {
				Adzuki.Ajax.get('/LivePlanner/sessionLibraryVideos/1')
				.then(function _showFilterForm(html) {
					$modal.find('.video-library-contents').html(html);
					Adzuki.Form.initAjaxForm('VideoFilter');
				});
			} else {
				Adzuki.Ajax.get('/Videos/library/' + source + '/1')
				.then(function _showFilterForm(html) {
					$modal.find('.modal-body').html(html);
					Adzuki.Form.initAjaxForm('VideoFilter');
				});
			}
		});

		$modal.find('#videofilter-agent_video_category_id').on('change', function getSubcats() {
			catId = $(this).val();
			parentGroup = $(this.options[this.selectedIndex]).parent().attr('label');

			if ((catId === '' || catId === null) || parentGroup === 'Global Categories') {
				$('.edit-video-subcat').addClass('hidden');
			}

			if (catId !== '' && catId !== null) {
				if (parentGroup !== 'Global Categories') {
					Adzuki.Ajax.get('/Videos/getSubCatList/' + catId)
						.then(function success(data) {
							if (data[0] === 0) {
								$('.edit-video-subcat').addClass('hidden');
							} else {
								$('.edit-video-subcat').removeClass('hidden');
								$("#videofilter-agent_video_subcategory_id").html(data);

							}
						});
				}
			}
		});

	};

	form.success = function success(response)
	{
		var source = $('#video-library-source').val();

		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		if (source === 'liveplanner') {
			Adzuki.Ajax.get('/LivePlanner/sessionLibraryVideos/')
			.then(function _showFilterForm(html) {
				$modal.find('.video-library-contents').html(html);
				Adzuki.Form.initAjaxForm('VideoFilter');
			});
		} else if (source === 'ho') {
			if (!Adzuki.Form.hasError(response)) {
				window.location.href = response['data'];
			}

			return false;
		} else {
			Adzuki.Ajax.get('/Videos/library/' + source)
			.then(function _showFilterForm(html) {
				$modal.find('.modal-body').html(html);
				Adzuki.Form.initAjaxForm('VideoFilter');
			});
		}
	};
}(jQuery, window.Adzuki || {}));